import { Descriptions, Modal } from "antd"
import dayjs from "dayjs"
import React from "react"

const ModalActiveSimDetail = ({ record, open, onClose }) => {
  return (
    <Modal
      title="Thông tin thuê bao"
      open={open}
      onCancel={onClose}
      footer={null}
      width={700}
    >
      <Descriptions bordered column={2}>
        <Descriptions.Item label="Khách hàng">
          {record.customer}
        </Descriptions.Item>
        <Descriptions.Item label="Số căn cước">
          {record.customer}
        </Descriptions.Item>
        <Descriptions.Item label="Số thuê bao">
          {record.phone}
        </Descriptions.Item>
        <Descriptions.Item label="Nhà mạng">
          {record.phone}
        </Descriptions.Item>
        <Descriptions.Item label="Gói cước">{record.package}</Descriptions.Item>
        <Descriptions.Item label="Ngày kích hoạt">
          {dayjs(record.activationDate).format("DD/MM/YYYY")}
        </Descriptions.Item>
        <Descriptions.Item label="Thời hạn sử dụng">
          {dayjs(record.expiryDate).format("DD/MM/YYYY")}
        </Descriptions.Item>
        <Descriptions.Item label="Ngày thu hồi">
          {dayjs(record.recoveryDate).format("DD/MM/YYYY")}
        </Descriptions.Item>
      </Descriptions>
    </Modal>
  )
}

export default ModalActiveSimDetail
